import { render, staticRenderFns } from "./IntroduceMe.vue?vue&type=template&id=88b1f0de&scoped=true"
import script from "./IntroduceMe.vue?vue&type=script&lang=js"
export * from "./IntroduceMe.vue?vue&type=script&lang=js"
import style0 from "./IntroduceMe.vue?vue&type=style&index=0&id=88b1f0de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b1f0de",
  null
  
)

export default component.exports